import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@nwwp/ui-shadcn'

/**
 * Small "?" affordance that reveals an explanatory note on hover or focus.
 *
 * Note: `retirement_calculator` and `rentvsbuycalc` each still carry a local copy of this
 * component; new callers should use this one.
 */
export function TooltipIcon({
  title,
  'aria-label': ariaLabel = 'More information',
}: {
  title: string
  'aria-label'?: string
}) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            aria-label={ariaLabel}
            className="ml-1 inline-flex size-[18px] cursor-help items-center justify-center rounded-full bg-smoke text-body-xs font-bold text-neutral-dark"
          >
            ?
          </span>
        </TooltipTrigger>
        <TooltipContent className="text-subtitle">{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
